import store from '@/store'
import { selectForegroundColor } from '@/utils/color'

export default class requirementTypesApi {
  static getBackgroundColour (cardType) {
    if (cardType && cardType.color && this.cardTypeExists(cardType)) {
      return 'rgb(' + cardType.color.red + ',' + cardType.color.green + ',' + cardType.color.blue + ')'
    } else {
      return '#eeeeee'
    }
  }

  static getTextColour (cardType) {
    if (cardType && cardType.color && this.cardTypeExists(cardType)) {
      return selectForegroundColor(cardType.color.red, cardType.color.green, cardType.color.blue)
    } else {
      return '#000000'
    }
  }

  static async cardTypeExists (cardType) { // requires async, don't know why
    if (!cardType) {
      return false
    }
    const cardTypes = store.state.requirementTypes.requirementTypes
    return cardTypes.includes(cardType.id)
  }

  static async updateRequirementType (workflowId, requirementType, payload) {
    const {
      id,
      title,
      color: { red, green, blue },
      description,
      showInBacklog,
      triggerType,
      queryType,
      aggregateType,
      defaultType,
      generateWithAI,
      order
    } = requirementType

    const input = {
      title,
      color: { red, green, blue },
      description,
      showInBacklog,
      triggerType,
      queryType,
      aggregateType,
      defaultType,
      generateWithAI,
      order,
      ...payload
    }
    await store.dispatch('requirementTypes/updateRequirementType', { workflowId, id, input })
  }
}
